import { render, staticRenderFns } from "./CitiesForm.vue?vue&type=template&id=ccb0cc84&"
import script from "./CitiesForm.vue?vue&type=script&lang=js&"
export * from "./CitiesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports